import { MenuProps } from 'components/Menu/Types'
import { Menu } from 'components/Menu/Menu'
import { Item, Section } from '@react-stately/collections'
import { Key } from 'react'
import { observer } from 'mobx-react-lite'
import { useAlmanacEditorState } from 'stores/EditorState'
import { FontFamilyType } from 'utils/fontUtils'
import { useFontWeight } from 'common/Prose/Toolbar/hooks/useFontWeight'
import { useRootStore } from 'stores/RootStore'
import { FONT_WEIGHTS } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/constants'
import { WeightName } from 'common/Prose/Toolbar/components/Format/components/MainStylePane/components/FontWeight/util'
import { FontWeightType } from 'components/VisualStudioPlayground/VisualEditor/Types'

export const FontWeightSubMenu = observer(
  ({ onAction, menuType = 'dropdown' }: Pick<MenuProps<any>, 'menuType' | 'onAction'>) => {
    const editorState = useAlmanacEditorState()
    const { googleFonts } = useRootStore()
    const { activeWeights, activeFamilies } = editorState || {
      activeWeights: new Set<keyof typeof FONT_WEIGHTS>(),
      activeFamilies: new Set<FontFamilyType>(),
    }
    const activeFamily: FontFamilyType | undefined = Array.from(activeFamilies).pop()
    const weights: FontWeightType[] = activeFamily ? googleFonts.get(activeFamily)?.weights || [300] : [300]

    const { setFontWeight } = useFontWeight()

    const handleAction = (action: Key) => {
      onAction?.(action)
      setFontWeight(action as WeightName)
    }

    return (
      <Menu
        onAction={handleAction}
        menuType={menuType}
        selectedKeys={activeWeights}
        selectionMode="multiple"
        aria-label="Font Weight"
      >
        <Section>
          {weights.map((weight) => {
            return (
              <Item key={FONT_WEIGHTS[weight]} textValue={FONT_WEIGHTS[weight]}>
                <span
                  style={{
                    fontWeight: weight,
                  }}
                >
                  {FONT_WEIGHTS[weight]}
                </span>
              </Item>
            )
          })}
        </Section>
      </Menu>
    )
  },
)
